import script from "./RequestsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./RequestsList.vue?vue&type=script&setup=true&lang=ts"

import "./RequestsList.vue?vue&type=style&index=0&id=712deb7a&lang=css"

const __exports__ = script;

export default __exports__